import riveWASMResource from '@rive-app/canvas/rive.wasm';
import { Rive, RuntimeLoader } from '@rive-app/canvas';

RuntimeLoader.setWasmUrl(riveWASMResource);

import Homework from '../../../assets/animations/sofabuddy_homework.riv';
import Learning from '../../../assets/animations/sofabuddy_learning.riv';
import Explanation from '../../../assets/animations/sofabuddy_explanation.riv';

const riveInstances = [];
const riveAnimations = [
  { name: 'homework', file: Homework },
  { name: 'learning', file: Learning },
  { name: 'explanation', file: Explanation }
];

const initializeRiveAnimations = () => {
  new Foundation.Accordion($('[data-accordion]'));

  riveAnimations.forEach(animation => {
    const r = new Rive({
      src: animation.file,
      canvas: document.getElementById(`sofabuddy-${animation.name}`),
      autoplay: false,
      onLoad: () => {
        r.resizeDrawingSurfaceToCanvas();
      }
    });
    riveInstances.push(r);
  });
};

const createObserver = (divId, riveInstance) => {
  let hasPlayed = false;

  const observer = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !hasPlayed) {
        riveInstance.play();
        hasPlayed = true;
        observer.unobserve(entry.target);
      }
    });
  });

  const target = document.getElementById(divId);
  observer.observe(target);
};

$(document).on('turbolinks:before-visit', () => {
  Turbolinks.clearCache();
});

preventCachedExecution(function() {
  if (document.querySelector('.sofabuddy-guidance-page')) {
    initializeRiveAnimations();
    createObserver('sofabuddy-homework', riveInstances[0]);
    createObserver('sofabuddy-learning', riveInstances[1]);
    createObserver('sofabuddy-explanation', riveInstances[2]);
  }
});
